// extracted by mini-css-extract-plugin
module.exports = {"root":"view-hoc-action_root__NTRjn","with_label":"view-hoc-action_with_label__VwAb9","label":"view-hoc-action_label__LRjh5"};